import type { SessionUser } from "./session";

/**
 * A specialist works their own schedule only: every specialist picker (the week filter, the
 * booking page, the patient's Прийоми tab) is fixed to them and hidden. Admins and managers
 * run the clinic's schedule and keep the choice. The API already books a specialist's own
 * schedule when no id is sent; passing it explicitly keeps the week filter in step.
 */
export function ownSpecialistId(session: Pick<SessionUser, "id" | "role">): string | undefined {
  return session.role === "specialist" ? session.id : undefined;
}
